export const GET_CUSTOMER_STATUS = 'GET_CUSTOMER_STATUS';
export const GET_CUSTOMER_RATINGS = 'GET_CUSTOMER_RATINGS';
